<template>
  <div class="top-block">
    <div class="left">
      <img class="avatar" :src="logoURL" alt="club-logo" />
      <LikesBlock :rating="rating" />
    </div>
    <div class="right">
      <div class="name">
        <p>{{ clubTitle }}</p>
      </div>
      <SocialLinksComponent :links="socialLinks" />
      <LikesBlock :rating="rating" />
      <div class="bottom-block">
        <div v-if="phones" class="phones">
          <div class="phones-container" :class="{ hide: !phones.length }">
            <a
              v-for="el in phones"
              :key="el.id"
              :href="`tel:${phonePrefix}${el.value}`"
            >
              <i class="icon-phone" />
              {{ phonePrefix }}{{ el.value }}
            </a>
          </div>
          <div v-if="clubSite" class="address">
            <a class="site" :href="clubSite" target="_blank">
              <i class="icon-website" />
              <p>{{ clubSite }}</p>
            </a>
          </div>
        </div>
        <Scheduler
          :schedule-obj="scheduleData"
          :is-club="true"
          :trigger="'hover'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LikesBlock from '@/components/Trainer/LikesBlock'
import SocialLinksComponent from '@/components/Common/SocialLinksComponent'
import Scheduler from '@/components/Common/Scheduler/SсhedulePopover'

export default {
  name: 'TopClubBlock',
  components: {
    LikesBlock,
    SocialLinksComponent,
    Scheduler
  },
  props: {
    club: {
      type: Object,
      default: () => {}
    },
    logoURL: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      phoneMask: 'user/getMask'
    }),
    socialLinks() {
      return this.club?.club?.social_networks
    },
    rating() {
      return this.club?.club?.rating
    },
    clubTitle() {
      return this.club?.club?.title
    },
    phones() {
      return this.club?.club?.phones
    },
    phonePrefix() {
      const { prefix } = this.phoneMask
      return prefix ? `+${prefix}` : ''
    },
    clubSite() {
      return this.club?.club?.site
    },
    scheduleData() {
      return this.club?.club?.scheduleConverted
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/css/variables';

.top-block {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.left {
  width: 40%;
}

.avatar {
  border-radius: 3px;
}

.email,
.site p {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #000;
}

.right {
  width: 57%;
  display: flex;
  flex-direction: column;

  .likes-block {
    display: none;
  }

  .name {
    line-height: 1.2;
    margin-bottom: 10px;

    p {
      font-size: 16px;
    }
  }

  .phones {
    .address {
      i {
        display: none;
      }
    }

    a {
      color: #000000;
      display: block;
      font-size: 13px;
      line-height: 1.2;
      margin-bottom: 3px;

      i {
        display: none;
      }
    }
  }

  .soc-links-block {
    order: 4;
    margin: 10px 0 0 0;
  }

  .bottom-block {
    .scheduler {
      display: none;
    }
  }
}

@media (min-width: 768px) {
  .top-block {
    padding: 0;
  }

  .left {
    display: none;
  }

  .right {
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 20px;

    .likes-block {
      display: flex;
      margin-bottom: 5px;
    }

    .soc-links-block {
      display: none;
    }

    .name {
      line-height: 1;
      width: 100%;

      p {
        display: inline-block;
        font-size: 38px;
        color: #474747;

        &:first-child {
          margin-right: 5px;
        }
      }
    }

    .phones {
      width: 75%;
      padding: 15px;
      background-color: $gray-lighter;
      border: 1px solid #f0f0f0;
      border-radius: 3px;
      line-height: 1.4;
      display: flex;
      justify-content: space-between;

      &-container {
        &.hide {
          display: none;
        }
      }

      .address {
        font-size: 18px;
        width: 60%;

        .site {
          display: flex;
          align-items: center;

          p {
            color: #474747;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        i {
          font-size: 18px;
          color: $primary;
          display: inline-block;
          margin-right: 3px;
        }
      }

      a {
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #474747;
        margin-bottom: 10px;

        &:last-child {
          margin-bottom: 0;
        }

        i {
          font-size: 20px;
          color: $primary;
          display: inline-block;
        }
      }
    }

    .bottom-block {
      width: 100%;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: center;

      .scheduler {
        display: flex;
        height: 100%;
        padding: 15px 0;

        span {
          font-size: 18px;
          color: #474747;
          margin-right: 15px;
        }

        i {
          font-size: 24px;
          color: $primary;
        }
      }
    }
  }
}
</style>
